import { createFileRoute } from '@tanstack/react-router';
import { FinanceLayout } from '@/components/finance';
import { FloatingHelp, HELP_TOPICS, OnboardingChecklistLink } from '@/components/help';

export const Route = createFileRoute('/admin/finance')({
  component: FinancePage,
});

function FinancePage() {
  return (
    <>
      <FinanceLayout />
      <FloatingHelp topic={HELP_TOPICS.finance} footer={<OnboardingChecklistLink />} />
    </>
  );
}
